
export const panelPMaxSectionName = 'PANEL DEFINITION'

export default function panelSectionName({isNeo}) {
    if (!isNeo) {
        return panelPMaxSectionName
    }
    return null
}